import React, { useCallback } from 'react';
import { Attachments } from '../../index';
import checkClick from '@src/ds/Utils/CheckClick';

export type AttachmentButtonProps = {
  enabled: boolean;
  code: string;
  attachments: Attachments[];
};

const AttachmentButton = ({ enabled, code, attachments }: AttachmentButtonProps) => {

  const checkAfterClick = useCallback((event: any) => {
    const rootElement = document.querySelector(`[data-code="${code}"]`) as HTMLDivElement;

    if (checkClick(event)) {
      rootElement.querySelector('.smartplayer__attachment')?.classList.remove('smartplayer__attachment--opened');
    }
  }, [code]);

  const onAttachmentOpen = useCallback((event: any) => {
    event.preventDefault();
    event.stopPropagation();

    const rootElement = document.querySelector(`[data-code="${code}"]`) as HTMLDivElement;

    // Fechar outros dropdowns
    const volumeButton = rootElement.querySelector('.smartplayer__volume') as HTMLButtonElement;
    if (volumeButton) {
      volumeButton.classList.remove('smartplayer__volume--opened');
    }

    const configurationButton = rootElement.querySelector('.smartplayer__configuration') as HTMLButtonElement;
    if (configurationButton) {
      configurationButton.classList.remove('smartplayer__configuration--opened');
      configurationButton.classList.remove('smartplayer__quality--opened');
      configurationButton.classList.remove('smartplayer__velocity--opened');
      configurationButton.classList.remove('smartplayer__subtitle--opened');
    }

    const aiButton = rootElement.querySelector('.smartplayer__ai') as HTMLButtonElement;
    if (aiButton) {
      aiButton.classList.remove('smartplayer__ai--opened');
    }

    // Toggle do dropdown de attachment
    const attachmentContainer = event.currentTarget?.parentElement;
    attachmentContainer?.classList.toggle('smartplayer__attachment--opened');
  }, [code]);

  const handleAttachmentClick = useCallback((link: string) => () => {
    // Abrir link em nova aba
    if (link) {
      window.open(link, '_blank', 'noopener,noreferrer');
    }

    // Fechar dropdown após clicar
    const rootElement = document.querySelector(`[data-code="${code}"]`) as HTMLDivElement;
    rootElement.querySelector('.smartplayer__attachment')?.classList.remove('smartplayer__attachment--opened');
  }, [code]);

  return enabled ? (
    <div className="smartplayer__attachment" onClick={checkAfterClick}>
      <button className="smartplayer__bar-button" type="button" onClick={onAttachmentOpen}>
        <div className="icon icon--attachment">
          <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 512 512" fill="currentColor">
            <path d="M 239.85 47.374 C 290.554 -3.249 372.836 -3.249 423.54 47.374 C 474.244 97.997 474.244 180.146 423.54 230.768 L 275.578 378.492 C 244.542 409.478 194.289 409.478 163.253 378.492 C 132.217 347.506 132.217 297.334 163.253 266.348 L 301.11 128.893 C 312.388 117.633 330.702 117.633 341.98 128.893 C 353.258 140.152 353.258 158.437 341.98 169.697 L 204.123 307.242 C 195.642 315.709 195.642 329.401 204.123 337.778 C 212.603 346.155 226.317 346.245 234.707 337.778 L 382.67 190.054 C 410.819 161.95 410.819 116.282 382.67 88.178 C 354.521 60.075 308.779 60.075 280.63 88.178 L 132.668 235.902 C 84.76 283.733 84.76 361.288 132.668 409.118 C 180.575 456.948 258.255 456.948 306.162 409.118 L 423.63 291.93 C 434.908 280.67 453.222 280.67 464.5 291.93 C 475.778 303.189 475.778 321.474 464.5 332.734 L 347.032 449.832 C 276.57 520.181 162.35 520.181 91.888 449.832 C 21.425 379.483 21.425 265.447 91.888 195.098 L 239.85 47.374 Z" />
          </svg>
        </div>
      </button>
      <div className="smartplayer__dropdownContainer">
        <div className="smartplayer__attachmentList">
          {attachments.map((attachment, index) => (
            <div key={index} className="smartplayer__attachmentItem">
              <input type="radio" id={`attachment-${index}`} name="attachment" value={index} />
              <label
                htmlFor={`attachment-${index}`}
                onClick={handleAttachmentClick(attachment.link)}
              >
                {attachment.title}
                <span className="smartplayer__attachmentItemBox"></span>
              </label>
            </div>
          ))}
        </div>
      </div>
    </div>
  ) : null;
};

export default AttachmentButton;
